<template>
    <div class="page">
        <div class="gridheader">
            <div class="row wrapper">
                <div class="col-md-2"></div>
                <div class="col-md-8 search-form">
                    <form method="get" action="">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>{{$t('DATE')}}</label>
                                    <datepicker v-model="params.date" :bootstrapStyling="true" format="dd.MM.yyyy" v-bind:placeholder="$t('STARTDATE')"></datepicker>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>{{$t('COMPANY')}}</label>
                                    <select v-model="params.ordererCompanyId" class="form-control secondary">
                                        <option value="">{{ $t('ALL') }}</option>
                                        <option v-for="company in companies.root" :value="company.companyId" :key="company.companyId">{{ company.companyName }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>{{$t('PRODUCT')}}</label>
                                    <select v-model="params.dentalSolutionTypeId" class="form-control secondary">
                                        <option v-for="ds in dentalsolutiontypes.root" :value="ds.dentalSolutionTypeId" :key="ds.dentalSolutionTypeId">{{ $t(ds.name) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 action">
                                <router-link :to="{ path: '/printdsdailyreport/', query: getQueryParams }" class="btn btn-white d-none d-md-block"><img src="../assets/img/icon-print.svg" alt=""> {{ $t('PRINT')}}</router-link>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>
        <div class="row reports report-monthly">
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr>
                            <td>{{$t('TIME')}}</td>
                            <td>{{$t('CLIENT')}}</td>
                            <td>{{$t('QUANTITY')}}</td>
                            <td>{{$t('FILESNUM')}}</td>
                            <td>{{$t('NAME')}}</td>
                            <td>{{$t('PLATFORMS')}}</td>
                            <td>{{$t('ISREPEAT')}}</td>
                            <td style="width: 5px;"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in report.root" :key="i">
                            <td>{{formatDate(row.updateDateTime)}}</td>
                            <td>{{row.companyName}}</td>
                            <td>{{row.num}}</td>
                            <td>{{row.filesNum}}</td>
                            <td>{{$t(row.name)}}</td>
                            <td>{{row.platforms}}</td>
                            <td>{{(row.isRepeat == '1') ? $t('YES') : $t('NO')}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row reports report-monthly fixed-bottom">
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr>
                            <td>{{$t('TOTALNUM')}}</td>
                            <td>{{$t('TOTALFILESNUM')}}</td>
                            <td>{{$t('TOTALREPEAT')}}</td>
                            <td style="width: 5px;"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{total.num}}</td>
                            <td>{{total.filesNum}}</td>
                            <td>{{total.repeat}}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapActions,
    mapGetters
}
from 'vuex'
import dentalsolutiontypesApi from '@/api/dentalsolutiontypes'
import dentalsolutionsApi from '@/api/dentalsolutions'
import moment from 'moment';

export default
{
    name: 'ReportsDs',
    data: function()
    {
        return {
            dentalsolutiontypes:
            {},
            companies:
            {
                root: [],
                totalCount: 0
            },
            report: {},
            params:
            {
                date: new Date(),
                ordererCompanyId: '',
                dentalSolutionTypeId: null,
            }
        };
    },
    created: function()
    {
        var me = this;

        me.getCompanies();
        me.getDentalSolutionTypes();
        me.getReport();
    },
    methods:
    {
        getDentalSolutionTypes()
        {
            const me = this;
            dentalsolutiontypesApi.selectRow({}, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.dentalsolutiontypes = Object.assign({}, data);
            });
        },
        getCompanies()
        {
            var me = this;
            dentalsolutionsApi.selectDentalSolutionUsers({}, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.companies = data;
                }
            });
        },
        setCompanyId(val)
        {
            var me = this;
            me.params.companyId = val;
        },
        getReport()
        {
            var me = this;
            const params = { ...me.params };

            params.date = moment(params.date).format('YYYY-MM-DD');

            dentalsolutionsApi.getReport(params, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.report = data;
                }
            });
        }
    },
    watch:
    {
        'params.date': function()
        {
            var me = this;
            me.getReport();
        },
        'params.ordererCompanyId': function()
        {
            var me = this;
            me.getReport();
        },
        'params.dentalSolutionTypeId': function()
        {
            var me = this;
            me.getReport();
        },
    },
    computed: {
        ...mapGetters([
            'globals'
        ]),
        getQueryParams()
        {
            const me = this;

            return {
                ...me.params,
                date: moment(me.params.date).format('YYYY-MM-DD')            
            }
        },
        total()
        {
            const me = this;

            let num = 0;
            let filesNum = 0;
            let repeat = 0;

            for(const item of me.report.root)
            {
                num += parseInt(item.num);
                filesNum += parseInt(item.filesNum);
                repeat += (item.isRepeat === '1') ? parseInt(item.filesNum) : 0;
            }

            return {
                num: num,
                filesNum: filesNum,
                repeat: repeat,
            };
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportsDsDaily.vue